import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { PerfilComponent } from "./perfil/perfil.component";
import { PerfilRoutingModule } from "./perfil.routing.module";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    declarations: [
        PerfilComponent
    ],
    imports: [
        CommonModule , 
        FormsModule , 
        ReactiveFormsModule , 
        SharedModule, 
        PerfilRoutingModule , 
        NgbAccordionModule
    ]
})
export class PerfilModule {}





